import { BsFacebook, BsInstagram, BsTwitter } from "react-icons/bs";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { Logo } from "../Assets";
import React from "react";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#1a1812] via-[#2a2620] to-[#1a1812] text-white w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3 group">
              <motion.img
                whileHover={{ rotate: [0, -10, 10, -10, 0] }}
                src={Logo}
                className="w-12 h-12 object-contain"
                alt="Royal Curry Leaf Logo"
              />
              <div>
                <span className="text-2xl font-bold bg-gradient-to-r from-[#947d25] to-[#ac9430] bg-clip-text text-transparent">
                  Royal Curry Leaf
                </span>
                <p className="text-xs text-[#227a32] font-semibold">
                  Authentic Indian Cuisine
                </p>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Experience the rich flavors of India with our handcrafted dishes,
              made with authentic spices and fresh ingredients.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#ac9430]">
              Quick Links
            </h3>
            <ul className="space-y-2">
              {[
                { to: "/", label: "Home" },
                { to: "/menu", label: "Menu" },
                { to: "/about", label: "About Us" },
                { to: "/services", label: "Services" },
                { to: "/gallery", label: "Gallery" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-[#ac9430] transition-colors duration-300 text-sm flex items-center gap-2 group"
                  >
                    <span className="w-0 group-hover:w-2 h-0.5 bg-[#ac9430] transition-all duration-300"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#ac9430]">
              Contact Us
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <FaPhoneAlt className="text-[#ac9430] mt-1 flex-shrink-0" />
                <div>
                  <p className="font-medium text-white">Phone</p>
                  <p>+1 (857) 605-5777</p>
                </div>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <FaEnvelope className="text-[#ac9430] mt-1 flex-shrink-0" />
                <div>
                  <p className="font-medium text-white">Email</p>
                  <p>royalcurryleaf@gmail.com</p>
                </div>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <FaMapMarkerAlt className="text-[#ac9430] mt-1 flex-shrink-0" />
                <div>
                  <p className="font-medium text-white">Address</p>
                  <p>34 SW Park, Westwood, MA 02090</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#ac9430]">
              Opening Hours
            </h3>
            <div className="flex items-start gap-3 text-sm text-gray-400 mb-6">
              <FaClock className="text-[#ac9430] mt-1 flex-shrink-0" />
              <div>
                <p className="font-medium text-white">Mon - Sun</p>
                <p>11:30 AM - 9:00 PM</p>
              </div>
            </div>

            <h3 className="text-lg font-semibold mb-4 text-[#ac9430]">
              Follow Us
            </h3>
            <div className="flex gap-3">
              {[
                { icon: <BsFacebook />, link: "#", label: "Facebook" },
                { icon: <BsInstagram />, link: "#", label: "Instagram" },
                { icon: <BsTwitter />, link: "#", label: "Twitter" },
              ].map((social, idx) => (
                <motion.a
                  key={idx}
                  whileHover={{ scale: 1.1, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                  href={social.link}
                  target="_blank"
                  rel="noreferrer"
                  className="w-10 h-10 bg-gradient-to-br from-[#947d25] to-[#ac9430] rounded-full flex items-center justify-center text-white hover:shadow-lg hover:shadow-[#ac9430]/50 transition-all duration-300"
                  aria-label={social.label}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400 text-center md:text-left">
            © {new Date().getFullYear()} Royal Curry Leaf™. All Rights Reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <Link
              to="/privacy"
              className="hover:text-[#ac9430] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="hover:text-[#ac9430] transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>

      {/* Decorative gradient overlay */}
      <div className="h-1 bg-gradient-to-r from-[#947d25] via-[#ac9430] to-[#947d25]"></div>
    </footer>
  );
};

export default Footer;
